import styled from "styled-components";
import { typography } from "dab-component-lib";
import { MediaStyle, GridRowStyle, basic } from "../../utils/style-utils";

export const CardRowStyle = GridRowStyle.extend`
  & > div {
    margin: 10px 5px 0;
    width: 100%;
  }
  ${MediaStyle.sm`
    & > div {
      width: calc(50% - 10px);
    }
  `}
  ${MediaStyle.lg`
    flex-wrap: nowrap;
    & > div {
      width: calc(25% - 10px);
    }
  `}
`;

export const CardIntroStyle = styled.div`
  text-align: center;
  ${typography.Body2};
  h2 {
    ${typography.Title1};
    color: ${basic.secondary};
    text-transform: uppercase;
    display: inline-block;
    border-bottom: 2px solid ${basic.secondary};
    margin-bottom: 0;
    margin-top: 25px;
  }
  p {
    display: none;
  }
`;

export const CategoriesSliderStyle = styled.div`
  margin: 1rem;
`;



// WEBPACK FOOTER //
// ./src/components/home/style.js